export default {
  mounted(el) {
    el.classList.add('before-fade');

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        el.classList.add('fade-in-visible');
        observer.unobserve(el); // only animate once
      }
    }, {
      threshold: 0.2
    });

    observer.observe(el);
  }
};
